<template>
    <div class="row">
        <div class="col-lg-6">
            <delete-statements></delete-statements>
            <clear-all></clear-all>
        </div>
        <div class="col-lg-6">
            <delete-logs></delete-logs>
        </div>
    </div>
</template>

<script>
    import DeleteStatements from './management/DeleteStatements'
    import DeleteLogs from './management/DeleteLogs'
    import ClearAll from './management/ClearAll'

    export default {

        components: {
            DeleteStatements, DeleteLogs, ClearAll
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$xapi.filters.context.loadOptions().then(() => {
                next()
            })
        }
    }
</script>
